// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ParameterChoiceId = (tag, _1) => ({tag, _1});
const InternalParameterChoice = value0 => $ParameterChoiceId("InternalParameterChoice", value0);
const CustomParameterChoice = value0 => $ParameterChoiceId("CustomParameterChoice", value0);
const eqParameterChoiceId = {
  eq: x => y => {
    if (x.tag === "InternalParameterChoice") {
      if (y.tag === "InternalParameterChoice") { return Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.eqInternalParameterChoice.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "CustomParameterChoice") {
      if (y.tag === "CustomParameterChoice") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordParameterChoiceId = {
  compare: x => y => {
    if (x.tag === "InternalParameterChoice") {
      if (y.tag === "InternalParameterChoice") { return Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.ordInternalParameterChoic.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "InternalParameterChoice") { return Data$dOrdering.GT; }
    if (x.tag === "CustomParameterChoice") {
      if (y.tag === "CustomParameterChoice") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqParameterChoiceId
};
const genericParameterChoiceId = {
  to: x => {
    if (x.tag === "Inl") { return $ParameterChoiceId("InternalParameterChoice", x._1); }
    if (x.tag === "Inr") { return $ParameterChoiceId("CustomParameterChoice", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "InternalParameterChoice") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "CustomParameterChoice") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showParameterChoiceId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.showInternalParameterChoiceId.show(v)]})({
      reflectSymbol: () => "InternalParameterChoice"
    });
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "CustomParameterChoice"});
    return x => {
      if (x.tag === "InternalParameterChoice") { return $0["genericShow'"](x._1); }
      if (x.tag === "CustomParameterChoice") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeParameterChoiceId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "InternalParameterChoice"
    })({unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.unscrambleDecodeInternalParameterChoiceId.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "CustomParameterChoice"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)})))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $ParameterChoiceId("InternalParameterChoice", $1._1); }
      if ($1.tag === "Inr") { return $ParameterChoiceId("CustomParameterChoice", $1._1); }
      $runtime.fail();
    };
  })()
};
const ufromJSONKeyParameterChoiceId = /* #__PURE__ */ (() => ({fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeParameterChoiceId.unsafeDecode)}))();
const encodeParameterChoiceId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericParameterChoiceId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InternalParameterChoice"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.encodeInternalParameterChoiceId.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CustomParameterChoice"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          return $1.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeParameterChoiceId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericParameterChoiceId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InternalParameterChoice"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.decodeInternalParameterChoiceId.decode
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "CustomParameterChoice"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
const asJSONKeyParameterChoiceId = /* #__PURE__ */ (() => (
  {asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeParameterChoiceId.encode, decodeParameterChoiceId.decode)}
))();
export {
  $ParameterChoiceId,
  CustomParameterChoice,
  InternalParameterChoice,
  asJSONKeyParameterChoiceId,
  decodeParameterChoiceId,
  encodeParameterChoiceId,
  eqParameterChoiceId,
  genericParameterChoiceId,
  ordParameterChoiceId,
  showParameterChoiceId,
  ufromJSONKeyParameterChoiceId,
  unscrambleDecodeParameterChoiceId
};
